/** @jsxImportSource @emotion/react */

import { useCallback } from "react";
import { useIntl } from "react-intl";

import { css } from "@emotion/react";
import { Box, Typography } from "@material-ui/core";

import { useModal } from "../context/modal";
import theme from "../styles/theme";

const policyDialogContent = css`
  width: 400px;
  max-height: 107px;
  overflow-y: auto;
  padding: ${theme.spacing(0, 2.5)};
  margin-bottom: ${theme.spacing(1.5)}px;

  .MuiTypography-root {
    line-height: normal;
  }
`;

interface Args {
  onOK?: () => void;
}

const usePopupPolicy = (): ((args?: Args | undefined) => void) => {
  const intl = useIntl();
  const [showModal, hideModal] = useModal();

  const popupPolicyModal = useCallback(
    (args?: Args | undefined) => {
      const { onOK } = args ?? {};
      showModal({
        title: intl.formatMessage({
          id: "popout-title.over-charge-policy",
        }),
        content: (
          <Box css={policyDialogContent}>
            <Typography variant="body2" gutterBottom>
              {intl.formatMessage({
                id: "popout-context.over-charge-policy.live",
              })}
            </Typography>
            <Typography variant="body2">
              {intl.formatMessage({
                id: "popout-context.over-charge-policy.vod",
              })}
            </Typography>
          </Box>
        ),
        actions: [
          {
            primary: true,
            label: intl.formatMessage({ id: "btn.ok" }),
            onClick: () => {
              hideModal();
              onOK?.();
            },
          },
        ],
      });
    },
    [hideModal, showModal, intl]
  );

  return popupPolicyModal;
};

export default usePopupPolicy;
